// Agenda : trie les rendez-vous par date (custom_excerpt « JJ/MM/AAAA HH:MM | Lieu », une ligne par date),
// masque ceux qui sont passés et n'en garde que trois.
import { lireDate as lire } from "./rdv";

export default function agenda() {
    const bloc = document.getElementById("agenda");
    if (!bloc) return;
    const liste = bloc.querySelector(".agenda");
    const items = [...liste.querySelectorAll("li[data-date]")];

    const maintenant = new Date();
    const futurs = items
        .map((li) => ({ li, d: lire(li.dataset.date) }))
        .filter((x) => x.d && x.d >= maintenant)
        .sort((a, b) => a.d - b.d);

    items.forEach((li) => { li.hidden = true; });
    futurs.slice(0, 3).forEach((x) => { x.li.hidden = false; liste.appendChild(x.li); });

    const vide = bloc.querySelector(".agenda-vide");
    if (vide) vide.hidden = futurs.length > 0;
    liste.hidden = futurs.length === 0;
}
